import React, { useEffect } from "react";
import { FieldArray, getFormValues, reduxForm } from "redux-form";
import { HostsForm } from "../ad_settings_modal/host_names_form";
import { ModalContentWrapper } from "./accept_advertisement_modal_helpers";
import { updateShow } from "../../../../action_managers/shows";
import { handleRespPromise } from "../../../../lib/http";
import { ValidationError } from "../../../../lib/errors";
import { showWarning } from "../../../../actions/app";

const confirmHostNameFormName = "confirmHostNameForm";

export let ConfirmHostNamesForm = props => {
  useEffect(() => {
    props.initialize(props.initialValues);
  }, [props.initialValues]);
  return (
    <form onSubmit={props.handleSubmit}>
      <FieldArray hideSubtitle={true} name="hosts" component={HostsForm} />
    </form>
  );
};
ConfirmHostNamesForm = reduxForm({
  form: confirmHostNameFormName,
})(ConfirmHostNamesForm);

const validateAddress = updatedAdSettings => {
  return (updatedAdSettings?.hosts?.[0]?.postalAddress?.StreetAddress?.length ?? 0) < 1;
};

export const confirmMailingPageConfig = props => {
  return {
    formName: confirmHostNameFormName,
    title: "Confirm Mailing Address",
    subTitle:
      "Please confirm your mailing address below. We’ll share this information with the brand so they can send samples of their product.",
    Content: (
      <ModalContentWrapper>
        <ConfirmHostNamesForm initialValues={props.show?.advertisementSettings} />
      </ModalContentWrapper>
    ),
    shouldDisable: validateAddress,
    onSubmit: () => {
      return props.dispatch((dispatch, getState) => {
        const updatedAdSettings = getFormValues(confirmHostNameFormName)(getState());
        if (validateAddress(updatedAdSettings)) {
          dispatch(showWarning("Address is required"));
          return Promise.reject(new ValidationError("Address is required"));
        }
        return dispatch(
          updateShow({ uuid: props.show.uuid, advertisementSettings: updatedAdSettings })
        ).then(handleRespPromise);
      });
    },
  };
};
